import {cs} from "../react/chain-services";
import {UseState} from "../react/use-state";
import {fragments} from "../react/fragments";
import {Effect} from "../react/effect";
import {Static2} from "../react/static-2";
import {GlobalEvent} from "../react/global-event";
import {chain} from "../utils/fs";

export const ScrollControl = ({next}) => cs(
    ["domRef", (_, next) => Static2({next})],
    ["state", (_, next) => UseState({next})],
    ({domRef, state}) => fragments(
        next({
            ref: domRef.set,
            start: (direction) => state.onChange(direction),
            stop: () => state.onChange(null),
        }),
        state.value && fragments(
            GlobalEvent({
                eventName: "mouseup",
                action: () => state.onChange(null),
            }),
            Effect({
                action: () => {
                    const dom = domRef.get();
                    if (!dom) {
                        return;
                    }

                    const domWidth = dom.getBoundingClientRect().width;
                    let stop;

                    const move = (distance) => {
                        dom.scrollTo({
                            left: dom.scrollLeft + distance * (state.value === "right" ? 1 : -1),
                            behavior: 'smooth'
                        });
                    };

                    (async () => {
                        let stopped = false;

                        stop = () => {stopped = true};

                        move(.8 * domWidth);
                        if (stopped) return;

                        // await waitTimeout(300);
                        // if (stopped) return;

                        stop = runWithSpeed({
                            getSpeed: (fromStart) => chain(
                                fromStart < 1500 ? .8 : fromStart < 3000 ? 2 : 5,
                                (_) => _ * domWidth * 1000/300,
                            ),
                            action: move,
                        });
                    })();

                    return () => stop();
                },
            })
        ),
    ),
);

const runWithSpeed = ({getSpeed, action}) => {
    const time1 = Date.now();
    let time = time1;
    const interval = setInterval(() => {
        const now = Date.now();
        action((now - time) / 1000 * getSpeed(now - time1));
        time = now;
    }, 600);
    return () => clearInterval(interval);
};
